interface Lead {
  id: string;
  created_at: string;
  first_name: string;
  last_name: string;
  company: string | null;
  sector: string | null;
  monthly_target: string | null;
  target_audience: string | null;
  action_type: string | null;
  notes: string | null;
  lead_context: string | null;
  status: string;
}

interface StatsCardsProps {
  leads: Lead[];
}

export default function StatsCards({ leads }: StatsCardsProps) {
  const total = leads.length;
  const today = leads.filter((l) => {
    const d = new Date(l.created_at);
    const now = new Date();
    return d.toDateString() === now.toDateString();
  }).length;
  const thisWeek = leads.filter((l) => {
    const d = new Date(l.created_at);
    const now = new Date();
    const weekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
    return d >= weekAgo;
  }).length;
  const converted = leads.filter((l) => l.status === 'converted').length;

  const stats = [
    { label: 'Toplam Lead', value: total, icon: 'ri-user-line', color: '#f0b429' },
    { label: 'Bugün', value: today, icon: 'ri-calendar-check-line', color: '#34d399' },
    { label: 'Bu Hafta', value: thisWeek, icon: 'ri-bar-chart-line', color: '#60a5fa' },
    { label: 'Dönüşüm', value: converted, icon: 'ri-trophy-line', color: '#f472b6' },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((s) => (
        <div
          key={s.label}
          className="rounded-2xl p-5"
          style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)' }}
        >
          <div className="flex items-center justify-between mb-3">
            <span className="text-gray-300 text-xs font-semibold uppercase tracking-wider">{s.label}</span>
            <div
              className="w-8 h-8 flex items-center justify-center rounded-xl"
              style={{ background: `${s.color}18` }}
            >
              <i className={`${s.icon} text-sm`} style={{ color: s.color }} />
            </div>
          </div>
          <p className="text-white text-3xl font-black">{s.value}</p>
        </div>
      ))}
    </div>
  );
}
